import { classnames, TTailwindString } from 'tailwindcss-classnames';
import Heading, { HeadingProps } from '../Heading';
import { useScreenBreakpoint } from 'lib/util/useScreenWidth';
import ImageCaption from '../ImageCaption/ImageCaption';
import { getCardTopBorderClass } from './card-utils';
import { Field } from '@sitecore-jss/sitecore-jss-react';
import useExperienceEditor from 'lib/sitecore/use-experience-editor';

interface CardHeadingProps {
  headingProps: HeadingProps;
  imageCaption?: Field<string>;
  cardEyebrow?: string;
  cardEyebrowClasses?: TTailwindString;
  descriptionDisabled?: boolean;
  isSingleCard?: boolean;
}

const CardHeading = ({
  headingProps,
  imageCaption = { value: '' },
  cardEyebrow = '',
  cardEyebrowClasses,
  descriptionDisabled = false,
  isSingleCard,
}: CardHeadingProps): JSX.Element => {
  const isExperienceEditor = useExperienceEditor();
  const { isMobileScreen } = useScreenBreakpoint();
  // In Experience Editor, always use desktop view (original logic: force 1440px)
  const isMobileView = isExperienceEditor ? false : isMobileScreen;

  if (!headingProps?.headingText) {
    return <></>;
  }
  const SingleCard = classnames({ 'lg:hidden': isSingleCard });
  const cardTopBorderClass = getCardTopBorderClass().concat(' ').concat(SingleCard);
  const imageCaptionValue = imageCaption.value;
  const displayCaption = !isSingleCard || isMobileView;
  const headingTopMargin = displayCaption && !imageCaptionValue ? 'mt-7' : 'mt-5';

  return (
    <>
      <span className={cardTopBorderClass} />
      <span className={classnames('cc-border-bottom')} />
      {displayCaption && <ImageCaption imageCaption={imageCaption} />}
      {cardEyebrow && (
        <div
          className={classnames('mt-4', 'leading-none', 'text-gray-darkGray', cardEyebrowClasses)}
        >
          {cardEyebrow}
        </div>
      )}
      <div className={classnames(headingTopMargin)}>
        <Heading {...headingProps} headingSize="m" descriptionDisabled={descriptionDisabled} />
      </div>
    </>
  );
};

export default CardHeading;
